import React, { FC, memo } from 'react';

import AdminListFieldTab from './AdminListFieldTab';

const Participants: FC = () => (
  <AdminListFieldTab
    fieldName="involved_parties"
    commentFieldName="comment_involved_parties"
    noteId="expert-note-participants"
    titleKey="tab_participants"
    hintKey="tab_participants_hint"
  />
);

export default memo(Participants);
